const commentItems = [
  {
    avatar: '吃瓜群众A',
    time: '5分钟前',
    content: '17吃瓜网真是我的快乐源泉！每天蹲点看最新爆料，比追剧还上头。这条顶流塌房的料我第一个信的，细节太真了。',
    likes: '2.3万',
  },
  {
    avatar: '娱乐圈观察家',
    time: '18分钟前',
    content: '作为一个混迹娱圈多年的老人，17吃瓜黑料网的可信度确实高于同行。他们的网红黑料基本都是实锤后才发，从不会为了流量乱编。',
    likes: '1.8万',
  },
  {
    avatar: '理性吃瓜人',
    time: '42分钟前',
    content: '建议大家理性看待明星爆料，17吃瓜爆料虽然靠谱但也不是100%。像之前某小花那件事最后就反转了，吃瓜也要有自己的判断力。',
    likes: '1.2万',
  },
  {
    avatar: '深夜吃瓜专业户',
    time: '1小时前',
    content: '自从关注了17吃瓜网再也不怕错过任何瓜了！今天这条选秀黑幕的报道看得我直呼好家伙，17c吃瓜黑料爆料果然名不虚传！',
    likes: '9.6千',
  },
];

const avatarColors = ['bg-primary-500', 'bg-accent-500', 'bg-secondary-500', 'bg-primary-600'];

export default function Comments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[860px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 md:h-8 rounded-full bg-accent-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            网友热评
          </h2>
          <span className="text-xs text-foreground-400 mt-1 whitespace-nowrap">· 精彩评论精选</span>
        </div>

        <div className="flex flex-col gap-4">
          {commentItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 md:w-11 md:h-11 rounded-full ${avatarColors[idx]} flex items-center justify-center flex-shrink-0`}>
                  <span className="text-background-50 font-bold text-sm whitespace-nowrap">
                    {item.avatar.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-800 whitespace-nowrap">{item.avatar}</div>
                  <div className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</div>
                </div>
                <div className="flex items-center gap-1 text-xs text-foreground-400 flex-shrink-0">
                  <i className="ri-thumb-up-line"></i>
                  <span className="whitespace-nowrap">{item.likes}</span>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}